var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"selectTab"},_vm._l((_vm.paymentMethod),function(item){return _c('li',{key:item.value,staticClass:"selectTab__item",class:{'selectTab__item--active': _vm.select === item.value},on:{"click":function($event){_vm.$emit('click', item.value)}}},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fa5b2fa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/SubscSelectPaymentMethod.vue
// module id = null
// module chunks = 